// Copies data-code to the clipboard when the button is pressed and says so to screen readers. Where the Clipboard
// API is missing or refused (older or in-app WebViews, non-secure pages), the older copy command is tried; if that
// fails too, the status line says so and gives the code.
if (!customElements.get('copy-code')) {
	class CopyCode extends HTMLElement {
		connectedCallback() {
			this.querySelector('button').addEventListener('click', () => this.copy());
		}
		async copy() {
			const copied = (await this.writeClipboard()) || this.copyWithCommand();
			const status = this.querySelector('[role="status"]');
			status.textContent = copied ? this.dataset.copied : this.dataset.failed;
			this.classList.toggle('is-copied', copied);
			this.classList.toggle('is-failed', !copied);
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				status.textContent = '';
				this.classList.remove('is-copied', 'is-failed');
			}, copied ? 2000 : 6000);
		}
		async writeClipboard() {
			if (!navigator.clipboard?.writeText) return false;
			try {
				await navigator.clipboard.writeText(this.dataset.code);
				return true;
			} catch {
				return false;
			}
		}
		copyWithCommand() {
			const field = document.createElement('textarea');
			field.value = this.dataset.code;
			field.setAttribute('readonly', '');
			field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
			this.appendChild(field);
			field.select();
			let copied = false;
			try {
				copied = document.execCommand('copy');
			} catch {
				copied = false;
			}
			field.remove();
			this.querySelector('button').focus({ preventScroll: true });
			return copied;
		}
	}
	customElements.define('copy-code', CopyCode);
}
